/**
 * Created by jacmai on 2/27/2017.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/actions/actionGroup/actionGroupInfo/actionGroupInfoView",
], function (Marionette, Messenger, ActionGroupInfoView) {
  var ActionGroupInfoController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "actiongroupinfo";
    },
    show: function (actionGroup) {
      this.view = new ActionGroupInfoView.actionGroupInfoView({ model: actionGroup });
      //if validation fails, call the appropriate functions to display the error
      actionGroup.on(
        "invalid",
        function (model, error) {
          if ("name" in error) {
            this.view.nameError(error["name"]);
          }
        },
        this,
      );

      //for new groups, open up a textbox for the name field automatically when shown
      if (actionGroup.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#actionGroupNameText");
          },
          this,
        );
      }

      this.view.on(
        "delete:group",
        function () {
          Messenger.yesNoDialog(
            "actions.dialog.delete",
            {
              yes: function () {
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Action",
                  id: actionGroup.id,
                  idType: "Action",
                  object: "Action",
                  source: "Action Details",
                });
                Messenger.vent.trigger("cancel:textbox"); //cancel any open textboxes
                actionGroup.deleteModel();
              },
            },
            this,
          );
        },
        this,
      );
      this.showRegion(this.view);
    },
  });

  return ActionGroupInfoController;
});
